module.exports = __webpack_public_path__ + "img/sixpackcarrier46.d7c082de.jpg";